// Import providers - each registers itself with embedRegistry on import
import { airtableProvider } from './airtable';
import { youtubeProvider } from './youtube';
import { loomProvider } from './loom';
import { wistiaProvider } from './wistia';
import { vimeoProvider } from './vimeo';
import { googleDriveProvider } from './google-drive';
import { googleDocsProvider } from './google-docs';
import { googleSheetsProvider } from './google-sheets';
import { googleSlidesProvider } from './google-slides';
import { typeformProvider } from './typeform';
import { spotifyProvider } from './spotify';
import { supademoProvider } from './supademo';
import { trelloProvider } from './trello';
import { figmaProvider } from './figma';
import { jsfiddleProvider } from './jsfiddle';
import { iframeProvider } from './iframe';
import { googleFormsProvider } from './google-forms';

// Re-export registry (now bundler can't tree-shake provider imports above)
export { embedRegistry } from '../registry';

// Export providers to prevent tree-shaking (they register themselves on import)
export const providers = [
  airtableProvider,
  youtubeProvider,
  loomProvider,
  wistiaProvider,
  vimeoProvider,
  figmaProvider,
  googleDriveProvider,
  googleDocsProvider,
  googleSheetsProvider,
  spotifyProvider,
  googleSlidesProvider,
  supademoProvider,
  googleFormsProvider,
  typeformProvider,
  trelloProvider,
  jsfiddleProvider,
  iframeProvider,
];
